export { ArrowRightNarrow as default } from './ArrowRightNarrow';
